/* tslint:disable */
/* eslint-disable */
/**
 * Document API
 * API for managing documents
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DocumentUploadUrlRequest interface.
 */
export function instanceOfDocumentUploadUrlRequest(value) {
    if (!('fileName' in value) || value['fileName'] === undefined)
        return false;
    if (!('contentType' in value) || value['contentType'] === undefined)
        return false;
    return true;
}
export function DocumentUploadUrlRequestFromJSON(json) {
    return DocumentUploadUrlRequestFromJSONTyped(json, false);
}
export function DocumentUploadUrlRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fileName': json['fileName'],
        'contentType': json['contentType'],
        'tags': json['tags'] == null ? undefined : json['tags'],
    };
}
export function DocumentUploadUrlRequestToJSON(json) {
    return DocumentUploadUrlRequestToJSONTyped(json, false);
}
export function DocumentUploadUrlRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'fileName': value['fileName'],
        'contentType': value['contentType'],
        'tags': value['tags'],
    };
}
